import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { mapTileUrlList } from '../../../components/Map/Layers/TilesLayer/mapTileUrlList';

export interface MapTileUrlState {
    value: string;
}

const initialState: MapTileUrlState = {
    value: mapTileUrlList.googleMaps,
};

export const mapTileUrlSlice = createSlice({
    name: 'mapTileUrlStateSetter',
    initialState,
    reducers: {
        setMapTileUrlState: (state, action: PayloadAction<string>) => {
            state.value = action.payload;
        },
    },
});

export const { setMapTileUrlState } = mapTileUrlSlice.actions;
export default mapTileUrlSlice.reducer;
